module.exports = __webpack_public_path__ + "img/1557614105749168129.5a968da3.png";